import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUp, Home, Mail, Phone } from 'lucide-react';

const MentionsLegales = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Mentions Légales - Frelon33™ | Expert Anti-Nuisibles Gironde";
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-stone-50 via-white to-green-50/30">
      {/* Hero Section Légale */}
      <section className="bg-gradient-to-r from-green-600 to-yellow-500 text-white py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center frelon-slide-up">
            <h1 className="text-4xl md:text-5xl font-black mb-4">
              Mentions Légales
            </h1>
            <p className="text-xl font-medium opacity-90">
              Informations légales obligatoires - <span className="frelon33-brand">Frelon33™</span>
            </p>
            <div className="mt-8">
              <Link
                to="/"
                className="frelon-btn frelon-btn-secondary inline-flex items-center space-x-2 px-6 py-3 bg-white text-green-600 hover:bg-green-50"
              >
                <Home className="h-5 w-5" />
                <span>Retour à l'accueil</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Contenu des Mentions Légales */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="frelon-card border-0 frelon-depth-2">
            <div className="prose prose-lg max-w-none">
              
              <h2 className="text-2xl font-bold text-gray-900 mb-6 frelon-heading">
                1. Informations sur l'éditeur du site
              </h2>
              
              <div className="bg-gradient-to-r from-green-50 to-yellow-50 p-6 rounded-2xl mb-8 border border-green-100">
                <h3 className="text-xl font-bold text-gray-900 mb-4">Coordonnées de l'entreprise</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-700">
                  <div>
                    <p><strong>Nom commercial :</strong> Frelon33™</p>
                    <p><strong>Dirigeant :</strong> Jessy Josselin Jordan Duchemin</p>
                    <p><strong>Statut :</strong> Auto-entrepreneur (Artisan)</p>
                    <p><strong>SIRET :</strong> 92880712200017</p>
                  </div>
                  <div>
                    <p><strong>Code NAF :</strong> 8129A — Désinfection, désinsectisation</p>
                    <p><strong>Date d'immatriculation :</strong> 20/05/2024</p>
                    <p><strong>Adresse :</strong> Communiquée sur demande</p>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                <div className="frelon-card bg-blue-50 border-blue-200">
                  <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center">
                    <Mail className="h-5 w-5 text-blue-600 mr-2" />
                    Contact
                  </h3>
                  <p className="text-gray-700">
                    <strong>E-mail :</strong> frelon33000@gmail.com<br />
                    <strong>Téléphone :</strong> 06 76 58 30 38
                  </p>
                </div>
                
                <div className="frelon-card bg-green-50 border-green-200">
                  <h3 className="text-lg font-bold text-gray-900 mb-3">
                    Responsable de publication
                  </h3>
                  <p className="text-gray-700">
                    <strong>Jessy Duchemin</strong><br />
                    Gérant de Frelon33™
                  </p>
                </div>
              </div>

              <h2 className="text-2xl font-bold text-gray-900 mb-6 frelon-heading">
                2. Hébergement du site
              </h2>
              
              <div className="frelon-card bg-purple-50 border-purple-200 mb-8">
                <p className="text-gray-700">
                  <strong>Hébergeur :</strong> Netlify<br />
                  <strong>Site web :</strong> <a href="https://www.frelon33.com" className="text-green-600 hover:text-green-700 font-semibold">https://www.frelon33.com</a>
                </p>
              </div>

              <h2 className="text-2xl font-bold text-gray-900 mb-6 frelon-heading">
                3. Propriété intellectuelle
              </h2>
              
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  L'ensemble du contenu de ce site (textes, images, logos, éléments graphiques, etc.) 
                  est la propriété exclusive de <strong className="frelon33-brand">Frelon33™</strong> 
                  ou fait l'objet d'une autorisation d'utilisation.
                </p>
                <p>
                  Toute reproduction, représentation, modification, publication, adaptation de tout ou partie 
                  des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, 
                  sauf autorisation écrite préalable de <strong className="frelon33-brand">Frelon33™</strong>.
                </p>
              </div>

              <h2 className="text-2xl font-bold text-gray-900 mb-6 mt-10 frelon-heading">
                4. Limitation de responsabilité
              </h2>
              
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  <strong className="frelon33-brand">Frelon33™</strong> s'efforce de fournir des informations 
                  aussi précises que possible sur ce site. Toutefois, nous ne pouvons garantir l'exactitude, 
                  la complétude et l'actualité des informations diffusées.
                </p>
                <p>
                  En conséquence, l'utilisateur reconnaît utiliser ces informations sous sa responsabilité exclusive.
                </p>
              </div>

              <h2 className="text-2xl font-bold text-gray-900 mb-6 mt-10 frelon-heading">
                5. Loi applicable
              </h2>
              
              <div className="frelon-card bg-yellow-50 border-yellow-200">
                <p className="text-gray-700">
                  Les présentes mentions légales sont régies par la loi française. 
                  En cas de litige, les tribunaux français seront seuls compétents.
                </p>
              </div>

              <div className="mt-12 text-center">
                <p className="text-sm text-gray-500 mb-4">
                  Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
                </p>
                <button
                  onClick={scrollToTop}
                  className="frelon-btn frelon-btn-primary inline-flex items-center space-x-2 px-6 py-3"
                >
                  <ArrowUp className="h-5 w-5" />
                  <span>Retour en haut</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MentionsLegales;